// THE TEAM IN AN AI ANSWER — the `team-people` view (functions/
// workspaceAnswer.js workspaceAiViews): the workspace's members, who is
// online now, and its AI agents, in the shared list frame
// (components/AssistantViewList.js). A member opens their profile; an agent,
// Team & agents. Read-only.
export const TeamPeopleAnswerView = {
  extends: 'AssistantViewList',
  dataAnswerView: 'team-people',
  viewLoad: 'teamPeopleAnswerLoad',
  viewModel: 'teamPeopleAnswerModel'
}
